import { useEffect, useMemo, useRef, useState } from "react";

export default function CustomSelect({
  value,
  onChange,
  options,              // [{ value:"g", label:"grams" }, ...]
  placeholder = "Select",
  className = "",
}) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  const currentLabel = useMemo(() => {
    const found = options?.find((o) => o.value === value);
    return found?.label ?? placeholder;
  }, [options, value, placeholder]);

  useEffect(() => {
    function onDown(e) {
      if (!rootRef.current) return;
      if (!rootRef.current.contains(e.target)) setOpen(false);
    }
    window.addEventListener("mousedown", onDown);
    window.addEventListener("touchstart", onDown, { passive: true });
    return () => {
      window.removeEventListener("mousedown", onDown);
      window.removeEventListener("touchstart", onDown);
    };
  }, []);

  return (
    <div ref={rootRef} className={`customSelect ${className}`}>
      <button
        type="button"
        className="customSelectTrigger"
        onClick={() => setOpen((s) => !s)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span>{currentLabel}</span>
        <span className="chev">▾</span>
      </button>

      {open ? (
        <div className="customSelectMenu" role="listbox">
          {options.map((opt) => (
            <div
              key={opt.value}
              role="option"
              aria-selected={opt.value === value}
              className={`customOption ${opt.value === value ? "active" : ""}`}
              onClick={() => {
                onChange(opt.value);
                setOpen(false);
              }}
            >
              {opt.label}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
